var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('router-view')],1)],1),(
      _vm.$route.name !== 'Home' &&
        _vm.$route.name !== 'LandingPage' &&
        _vm.$route.name !== 'HalteknopLanding'
    )?_c('bottom-navigation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }